import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { List } from 'immutable';
// TODO (BD): Figure out how to bring logging back in libs
// import Raven from 'raven-js';
import isString from 'hs-lodash/isString';
import getIn from 'immutable-less/transmute/getIn';
import { UnknownTypeKey, NonspecificTypeKey, NonspecificActionTypeExecutionStates, NonspecificActionTypeErrorTypes, NonspecificEnrollTypeEnrollmentStates } from 'automation-ui-log-events/constants/LogEventMessageConstants';
import { I18N_SEPARATOR } from 'automation-ui-i18n/i18nUtils';
import { ExecutionStates, LogEventTypes } from 'automation-ui-log-events/constants/LogEventConstants';
import { getType, getState, getAction, getEnrollType, getErrorType, getTriggerEnrollType } from 'automation-ui-log-events/records/LogEvent/utils';
import LogEventKeys from 'automation-ui-log-events/constants/LogEventKeys';
export const toPath = keys => {
  return List.isList(keys) ? keys.join(I18N_SEPARATOR) : '';
};
export const getPathKeyLength = path => isString(path) ? path.split(I18N_SEPARATOR).length : 0;

/*
const logMissingPath = () /* (path, level = 'error')=> {
  // TODO (BD): Figure out how to bring logging back in libs

  if (typeof Raven !== 'undefined') {
    Raven.captureMessage(`History log events: found no entry for ${path}!`, {
      level, // 'info', 'warning', or 'error'
    });
  }
};*/

const getMostSpecificPathAt = baseKey => {
  const baseKeyJSX = `${baseKey}_jsx`;
  const defaultKeyJSX = `${baseKey}.default_jsx`;
  const defaultKey = `${baseKey}.default`;
  if (isValidI18nKey(baseKeyJSX)) {
    return {
      path: baseKeyJSX,
      isJSXMessage: true
    };
  }
  if (isValidI18nKey(defaultKeyJSX)) {
    return {
      path: defaultKeyJSX,
      isJSXMessage: true
    };
  }
  if (isValidI18nKey(baseKey)) {
    return {
      path: baseKey,
      isJSXMessage: false
    };
  }
  if (isValidI18nKey(defaultKey)) {
    return {
      path: defaultKey,
      isJSXMessage: false
    };
  }
  return undefined;
};
const isNonspecificActionTypePath = basePath => {
  let isNonspecific = false;
  NonspecificActionTypeExecutionStates.forEach(executionState => {
    if (basePath.includes(executionState)) {
      isNonspecific = true;
      return;
    }
  });
  return isNonspecific;
};
export const getMostSpecificPathFromKeys = keys => {
  while (keys && !keys.isEmpty()) {
    const base = `${LogEventKeys.ROOT_KEY}.${toPath(keys)}`;
    const potentialPath = getMostSpecificPathAt(base);
    if (potentialPath) {
      return potentialPath;
    }

    // TODO (BD): Figure out how to bring logging back in libs
    // Don't report on intentionally nonspecific event copy
    if (!isNonspecificActionTypePath(base)) {
      // If we get down to the actionOrEnrollType with no errorOrSpecialType, log to sentry
      if (keys.last() && keys.size === 4) {
        //logMissingPath(base, 'info');
      }
      // ...state with no actionOrEnrollType, log to sentry
      if (keys.last() && keys.size === 3) {
        //logMissingPath(base, 'warning');
      }
      // ...only eventType, something seriously wrong
      if (keys.last() && keys.size === 2) {
        //logMissingPath(base, 'error');
      }
    }
    keys = keys.pop();
  }
  return undefined;
};
export const getActionTypeKey = logEvent => {
  const state = getState(logEvent);
  if (state && NonspecificActionTypeExecutionStates.includes(state)) {
    return NonspecificTypeKey;
  }
  const errorType = getErrorType(logEvent);
  if (state === ExecutionStates.FAIL_CONTINUE && errorType && NonspecificActionTypeErrorTypes.includes(errorType)) {
    return NonspecificTypeKey;
  }
  const action = getAction(logEvent);
  if (!action && state === ExecutionStates.FAIL_IRREPARABLE) {
    return UnknownTypeKey;
  }
  return getIn(['actionType'], action);
};
export const getEnrollTypeKey = logEvent => {
  const type = getType(logEvent);
  const state = getState(logEvent);
  if (type === LogEventTypes.PRE_ENROLLMENT) {
    return getTriggerEnrollType(logEvent);
  }
  if (state && NonspecificEnrollTypeEnrollmentStates.includes(state)) {
    return NonspecificTypeKey;
  }
  return getEnrollType(logEvent);
};